import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Newsletter, NewsletterState } from '../models/newsletter';

// Liste de diffusion (API /newsletters) : inscription avec double opt-in, confirmation, désinscription par lien
@Injectable({
  providedIn: 'root'
})
export class NewsletterService {

  private readonly host = environment.host + '/newsletters';

  constructor(private httpClient: HttpClient) { }

  // Envoie un e-mail de confirmation : rien n'est actif avant le clic sur le lien
  subscribe(email: string, partnerOffers: boolean, language?: string): Observable<{ message: string }> {
    return this.httpClient.post<{ message: string }>(this.host, { email, partnerOffers, language });
  }

  // Ancienne action NgRx (SaveNewsletterAction) : même inscription, newsletter seule
  save(newsletter: Newsletter): Observable<{ message: string }> {
    return this.subscribe(newsletter.email, false);
  }

  confirm(token: string): Observable<NewsletterState & { confirmed: boolean }> {
    return this.httpClient.post<NewsletterState & { confirmed: boolean }>(`${this.host}/confirm/${token}`, {});
  }

  unsubscribeState(token: string): Observable<NewsletterState & { email: string }> {
    return this.httpClient.get<NewsletterState & { email: string }>(`${this.host}/unsubscribe/${token}`);
  }

  unsubscribe(token: string, choice: { all?: boolean; newsletter?: boolean; partnerOffers?: boolean }): Observable<NewsletterState & { email: string }> {
    return this.httpClient.post<NewsletterState & { email: string }>(`${this.host}/unsubscribe/${token}`, choice);
  }

  // Sans lien sous la main : l'API envoie le lien de désinscription à l'adresse
  requestUnsubscribeLink(email: string): Observable<{ message: string }> {
    return this.httpClient.post<{ message: string }>(`${this.host}/unsubscribe-request`, { email });
  }

}
